import "../../assets/styles/product-view.css";
import React, { useEffect } from "react";
import image from "../../assets/images/vatrules_banner.jpeg";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import Banner from "../../components/Banner/Banner";
import product_image from "../../assets/images/VATRules.jpg";
import { FormattedMessage } from "react-intl";
import en_locale from "../../translations/en.json";
import de_locale from "../../translations/de.json";
import { useDispatch, useSelector } from "react-redux";
import Team from "../../components/Team/Team";
import MatchingProducts from "../../components/MatchingProducts/MatchingProducts";
import { setLang } from "../../redux/actions/settings";
import { useNavigate, useParams } from "react-router-dom";

const VATRules = () => {
  const lang = useSelector((state) => state.settings.lang);
  const messages = {
    de: de_locale,
    en: en_locale,
  };

  useEffect(() => {
    document.title = "VATRules";
  }, []);

  window.scrollTo(0, 0);

  const { language } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (language === "de" || language === "en") {
      dispatch(setLang(language));
    } else {
      navigate("/not-found");
    }
  }, []);

  return (
    <div>
      <div>
        <BreadCrumbs
          navItems={[
            {
              title: "eClear Store",
              href: `/store/${language}`,
            },
            {
              title: "VAT Suite",
              href: `/store/${language}/vat-suite`,
            },
            {
              title: "VATRules",
            },
          ]}
        />
      </div>
      <div>
        <div>
          <div className="column main">
            <Banner
              image={image}
              title={"VATRules"}
              productImage={product_image}
            />
            <input
              name="form_key"
              type="hidden"
              defaultValue="Sk3VlxqpWwfVfRQk"
            />
            <div
              id="authenticationPopup"
              data-bind="scope:'authenticationPopup', style: {display: 'none'}"
              style={{ display: "none" }}
            ></div>
            <div className="catalog-product-view ">
              <div className="product-infomation-wrapper">
                <input type="hidden" id="storeId" defaultValue={1} />
                <input type="hidden" id="currencySymbol" defaultValue="€" />
                <div className="product-information">
                  <div className="box-left">
                    <div className="use-case">
                      <h3 className="title">Use case</h3>
                      <FormattedMessage id="VATRules.useCase" />
                    </div>
                    <div className="features-and-benefits">
                      <div className="features">
                        <h3 className="title">Feature</h3>
                        <ul style={{ listStyleType: "circle" }}>
                          <li>
                            <FormattedMessage id="VATRules.feature1" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.feature2" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.feature3" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.feature4" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.feature5" />
                          </li>
                        </ul>{" "}
                      </div>
                      <div className="benefits">
                        <h3 className="title">Benefit</h3>
                        <ul style={{ listStyleType: "circle" }}>
                          <li>
                            <FormattedMessage id="VATRules.benefit1" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.benefit2" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.benefit3" />
                          </li>
                          <li>
                            <FormattedMessage id="VATRules.benefit4" />
                          </li>
                        </ul>{" "}
                      </div>
                    </div>
                    <Team />
                  </div>
                  <div className="box-right">
                    {/* REQUEST BUTTON */}
                    <form action={messages[lang]["ContactLink"]} method="get">
                      <div className="box-to-cart">
                        <span>
                          <FormattedMessage id="Request quotation" />
                        </span>
                        <button
                          className="action subscribe primary request-demo-now-header"
                          type="submit"
                        >
                          <FormattedMessage id="Reuqest offer" />
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <MatchingProducts />
          </div>
        </div>
      </div>
    </div>
  );
};
export default VATRules;
